<style lang="scss" scoped>
.index {
	width: 100%;
	height: 1400px;
	background: url('../../assets/pc/index-bg2.png');
}
.container {
	position: relative;
	z-index: 0;
	width: 100%;
	height: 1190px;
	background-position: center;
}
.index-image-bg,
.index-video-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 1190px;
}
.index-logo {
	position: absolute;
	left: 0;
	right: 0;
	margin: 630px auto 0 auto;
}
.video-btn {
	position: absolute;
	left: 0;
	right: 0;
	margin: 730px auto 0 auto;
	padding-left: 180px;
	cursor: pointer;
}
.left-block {
	position: absolute;
	bottom: 140px;
	left: 6%;
	width: 628px;
	height: 340px;
	.follow-block {
		position: relative;
		width: 100%;
		height: 190px;
		.follow-person {
			float: left;
			width: 75px;
			height: 178px;
			cursor: pointer;
			overflow: hidden;
			.follow-person-animate {
      	animation:animation1 12s linear infinite;
				transform-origin:100% 100%;
			}
			@keyframes animation1 {
				0%{ transform: rotate(15deg); }
				10%{ transform: rotate(15deg); }
				40%{ transform: rotate(0deg); }
				50%{ transform: rotate(0deg); }
				70%{ transform: rotate(15deg); }
				100%{ transform: rotate(15deg); }
			}
		}
		.follow-hide {
			position: absolute;
			top: 0;
			left: 75px;
			cursor: pointer;
		}
		.follow-items {
			float: right;
			width: 553px;
			height: 190px;
			background: url('../../assets/pc/follow-items.png');
			text-align: right;
			.handle {
				float: right;
				width: 24px;
				height: 190px;
				cursor: pointer;
			}
			.follow-item {
				position: relative;
				float: left;
				width: 150px;
				height: 114px;
				background: url('../../assets/pc/follow-item-bg.png');
				margin-top: 30px;
    		margin-left: 23px;
				padding-top: 5px;
    		padding-left: 5px;
				text-align: left;
				.name{
					position: absolute;
					left: 10px;
					bottom: -27px;
					color: #da82a2;
					font-size: 18px;
				}
			}
		}
	}
	.down-block {
		width: 467px;
		height: 150px;
		background: url('../../assets/pc/down-block-bg.png');
		display: flex;
		justify-content: space-between;
		.dowm-code {
			width: 118px;
			height: 118px;
			margin: 16px 25px 0 16px;
		}
		.title {
			margin-top: 2px;
			font-size: 16px;
			line-height: 34px;
			color: #ffeeca;
			letter-spacing: 1px;
		}
		.dowm-item {
			margin-bottom: 8px;
			margin-right: 8px;
			cursor: pointer;
		}
	}
}
.publish-block {
	position: absolute;
	bottom: 140px;
	right: 6%;
	width: 529px;
	height: 221px;
	background: url('../../assets/pc/publish-block-bg.png');
	padding: 21px 16px 0 31px;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	.banner-block {
		overflow: auto;
		.banner-content {
			width: 290px;
			height: auto;
			cursor: pointer;
		}
		.banner-progress {
			width: 291px;
			height: 2px;
			cursor: pointer;
			background: #ccc;
			border-radius: 5px;
			margin-top: 2px;
			.banner-progress-item {
				float: left;
				width: 97px;
				height: 4px;
				border-radius: 5px;
				position: relative;
    		top: -1px;
			}
			.banner-progress-choose {
				background: #ffeeca;
			}
		}
	}
	.publish-right {
		width: 190px;
		box-sizing: border-box;
		padding-left: 10px;
		text-align: right;
		.publish-item {
			width: 170px;
			border-bottom: 1px solid #f7ebbd;
			padding-bottom: 8px;
			margin-bottom: 10px;
			margin-top: 10px;
			text-align: left;
			cursor: pointer;
			.title {
				font-size: 14px;
				color: #ffeeca;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
			.ct {
				font-size: 14px;
				color: #fff;
			}
		}
		.more-btn {
			cursor: pointer;
			margin-top: 5px;
		}
	}
}
.video-play {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba($color: #000000, $alpha: 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
}
.slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-enter {
  transform: translateX(-10px);
  opacity: 0;
}
</style>

<template>
<div class="index" id="index">
	<div class="container">
		<!-- 背景 -->
		<div v-if="imageOrVideoBg == '2'" :style="{'background': 'url('+ indexBg +')'}" class="index-image-bg"></div>
		<video v-if="imageOrVideoBg == '1'" autoplay class="index-video-bg" :src="indexBg"></video>
		<img class="index-logo" :src="indexLogo" alt="logo">
		<img v-if="showVideoBtn" @click="showVideo" class="video-btn" src="../../assets/pc/video-btn.png" alt="video">
		<!-- 关注及下载 -->
		<div class="left-block">
			<!-- 关注 -->
			<div class="follow-block">
				<div @mousemove="followItemShow=true" @mouseout="followItemShow=false" class="follow-person">
					<img :class="{'follow-person-animate': !followItemShow}" src="../../assets/pc/follow-person.png" alt="person">
				</div>
				<img
					v-show="!followItemShow"
					@click="followItemShow = !followItemShow"
					class="follow-hide"
					src="../../assets/pc/follow-hide.png"
					alt="btn"
				>
				<transition name="slide-fade">
					<div v-show="followItemShow" class="follow-items">
						<div class="follow-item">
							<img :src="followPath1" alt="">
							<div class="name">{{followName1}}</div>
						</div>
						<div class="follow-item">
							<img :src="followPath2" alt="">
							<div class="name">{{followName2}}</div>
						</div>
						<div class="follow-item">
							<img :src="followPath3" alt="">
							<div class="name">{{followName3}}</div>
						</div>
						<div @click="followItemShow = !followItemShow" class="handle"></div>
					</div>
				</transition>
			</div>
			<!-- 下载 -->
			<div class="down-block">
				<img class="dowm-code" src="../../assets/pc/dowm-code.png" alt="">
				<div class="down-link">
					<div class="title">点击下载按钮或扫二维码下载游戏>>></div>
					<img @click="goPage('downAppleLink')" class="dowm-item" src="../../assets/pc/down-apple.png" alt="">
					<img @click="goPage('downTapLink')" class="dowm-item" src="../../assets/pc/down-tap.png" alt="">
					<img @click="goPage('downAndroidLink')" class="dowm-item" src="../../assets/pc/down-android.png" alt="">
					<img @click="goPage('downPCLink')" class="dowm-item" src="../../assets/pc/down-PC.png" alt="">
				</div>
			</div>
		</div>
		<!-- 公布 -->
		<div class="publish-block">
			<!-- 轮播 -->
			<div class="banner-block">
				<img
					v-for="(item, index) in bannerList"
					:key="item.wsId"
					v-show="index == bannerChooseNumber"
					@mouseout="interval"
					@mousemove="clearInterval"
					@click="goLink(item.wsUrl)"
					:src="item.wsImagePath"
					:alt="item.wsImageName"
					class="banner-content"
				>
				<div class="banner-progress">
					<div
						v-for="(item, index) in bannerList"
						:key="item.wsId"
						@click="chooseBanner(index)"
						:class="{'banner-progress-choose': bannerChooseNumber == index}"
						class="banner-progress-item">
					</div>
				</div>
			</div>
			<!-- 公告列表 -->
			<div class="publish-right">
				<div v-for="item in publishList" :key="item.newsId" @click="goNewsDetail(item.newsId)"  class="publish-item">
					<div :title="item.newsTitle" class="title">{{item.newsTitle}}</div>
				</div>
				<img @click="$router.push({name: 'p-more-experience'})" class="more-btn" src="../../assets/pc/more-btn.png" alt="more">
			</div>
		</div>
	</div>
	<p-footer></p-footer>
	<!-- 视频播放 -->
	<div v-show="videoShow" @click="hideVideo" class="video-play">
		<video id="video2" :src="videoPath"></video>
	</div>
	<!-- 背景音乐 http://fbbsoc-download.joymore.cn/brotherland/website/background-voice1.mp3 -->
    <audio
		autoplay
      	loop="loop"
      	:src="voicePath"
      	id="bg_voice"
    >您的浏览器不支持 audio 标签。</audio>
</div>
</template>

<script>
import Footer from '../../components/Footer'
export default {
	name: 'p-index',
	components: {
		'p-footer': Footer
	},
	data() {
		return {
			voicePath: require('../../assets/background-voice.mp3'),
			videoPath: '',
			videoShow: false,
			imageOrVideoBg: '1',
			indexBg: '',
			followItemShow: false,
			followName1: '',
			followPath1: '',
			followName2: '',
			followPath2: '',
			followName3: '',
			followPath3: '',
			downAppleLink: '',
			downTapLink: '',
			downAndroidLink: '',
			downPCLink: '',
			publishList: [],
			bannerList: [],
			bannerChooseNumber: 0,
			timeInterval: null,
			scrollObj: null,
			indexLogo: null,
			showVideoBtn: false,
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width < 850) {
			this.$router.push({name: 'm-index'});
		} else {
			this.init();
			this.interval();
		}
		document.addEventListener('visibilitychange', function () {
			// 用户离开了当前页面
			if (document.visibilityState === 'hidden') {
				document.getElementById("bg_voice").pause();
			}
			// 用户打开或回到页面
			if (document.visibilityState === 'visible') {
				document.getElementById("bg_voice").play();
			}
		});
	},
	methods: {
		// 初始化
		init() {
			this.$http.get('/api/website/getIndexInfo?platform=1').then((rsp) => {
				const data = rsp.result;
				// 视频
				this.videoPath = data.indexVideo.filePath;
				// 首页背景
				this.imageOrVideoBg = data.imageOrVideo;
				this.indexBg = data.indexImageVideo.filePath;
				// 下载
				this.downAppleLink = data.download.appstorePath;
				this.downTapLink = data.download.taptapPath;
				this.downAndroidLink = data.download.androidPath;
				this.downPCLink = data.download.pcPath;
				// 关注
				this.followName1 = data.microblog.fileName;
				this.followPath1 = data.microblog.filePath;
				this.followName2 = data.weixin.fileName;
				this.followPath2 = data.weixin.filePath;
				this.followName3 = data.customerService.fileName;
				this.followPath3 = data.customerService.filePath;
				// 公告
				this.publishList = data.news;
				// 轮播
				this.bannerList = data.banner;
				// 首页logo
				this.indexLogo = data.indexLogo.filePath;
				// 是否显示按钮
				this.showVideoBtn = data.wasShowButton === '1';
			});
		},
		interval() {
			this.timeInterval = setInterval(() => {
				if(this.bannerList.length <= 1) {
					clearInterval(this.timeInterval);
				} else {
					if(this.bannerChooseNumber == this.bannerList.length-1) {
						this.bannerChooseNumber = 0;
					} else {
						this.bannerChooseNumber ++;
					}
				}
			}, 8000);
		},
		clearInterval() {
			clearInterval(this.timeInterval);
		},
		goPage(link) {
			window.open(this[link], '_blank');
		},
		chooseBanner(index) {
			this.bannerChooseNumber = index;
		},
		goLink(link) {
			window.location.href = link;
		},
		goNewsDetail(id) {
			this.$router.push({name: 'p-news-detail', params: {newsId: id}});
		},
		showVideo() {
			this.videoShow = true;
			let video = document.getElementById("video2");
			video.play();
			let voice = document.getElementById("bg_voice");
			voice.pause();
		},
		hideVideo() {
			this.videoShow = false;
			let video = document.getElementById("video2");
			video.pause();
			let voice = document.getElementById("bg_voice");
			voice.play();
		}
	},
	beforeDestroy() {
		this.clearInterval();
	}
}
</script>
